import { Helmet } from "react-helmet-async";
import Achievements from "../components/Achievements.js";
import ContactUs from "../components/ContactUs.js";
import Footprints from "../components/Footprints.js";
import FrontPage from "../components/Front.js";
import LatestInsights from "../components/LatestInsights.js";
import Offerings from "../components/Offerings.js";
import ProcessFollow from "../components/ProcessFollow.js";
import RecentWorks from "../components/RecentWorks.js";
import TrustedClients from "../components/TrustedClients.js";
import WhyChoose from "../components/WhyChoose.js";

function Home() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Ayanshtech Solutions",
    url: "https://ayanshtechnology.com",
    logo: "https://ayanshtechnology.com/assets/logo.png",
    sameAs: [
      "https://www.facebook.com/profile.php?id=61579642918710&sk=about",
      "https://www.linkedin.com/company/ayanshtech-solutions",
      "https://x.com/AyanshtechS",
      "https://www.instagram.com/ayanshtechsolutions/",
    ],
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+91-8802319226",
        contactType: "Customer Support",
        areaServed: "IN",
        availableLanguage: ["English", "Hindi"],
      },
    ],
  };


  
 
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-TBY0X6ZCK5"></script>
        <script>

          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-TBY0X6ZCK5');
          `}
        </script>

        <meta name="google-site-verification" content="NS5N8vTv0YlUUTr5pQuRxJCTNt8Ep6Xf4uqbjHuLEJg" />
        <meta
          name="description"
          content="Boost business communication with AI Voice Assistants & VoIP solutions. Partner with India’s top DevOps experts at Ayanshtech Solutions for smarter scalability."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="India’s Leading VoIP & AI Voice Assistant Company | Ayanshtech Solutions"
        />
      
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta property="og:url" content="https://ayanshtechnology.com/" />
        <meta
          property="og:description"
          content="Make your business communication smarter with VoIP Calling, AI Voice Assistants, and DevOps Solutions — achieve faster growth with Ayanshtech Solutions."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Best VoIP & AI Voice Assistant Services in India | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Make your business communication smarter with VoIP Calling, AI Voice Assistants, and DevOps Solutions — achieve faster growth with Ayanshtech Solutions"
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />
        <link rel="canonical" href="https://ayanshtechnology.com" />
        <title>
          VoIP Service Provider in India | AI Voice Assistant Development &
          DevOps Consulting | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className="Home">
        <FrontPage />
        {/* <RecentWorks /> */}
        {/* <Achievements /> */}
        <Offerings />
        <WhyChoose />
        <ProcessFollow />
        <TrustedClients />
        <Footprints />
        {/* <LatestInsights /> */}
        <ContactUs />
      </div>
    </>
  );
}



export default Home;
